import React, { memo } from 'react';
import PropTypes from 'prop-types';

import paths from 'app/paths';
import { ViewLinkButton } from 'components';

const ClientActionsCell = memo((props) => {
  const {
    item: { id },
  } = props;
  return <ViewLinkButton to={paths.clientView.path} params={{ id }} />;
});

ClientActionsCell.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
};

export default ClientActionsCell;
